import fetch from '../core/axios'

const _method = 'post'

let _URL = {
  login: '/imc/merchant/login',// 登录 
  setpwd: '/imc/merchant/setpwd'// 修改密码
};

export default {

  login(data) {
    let param = {
      loginName: data.cserId,
      passwd: data.cserPwd
    }
    return fetch.post(_URL.login, param, {
      headers:{'x-time':data.timestamp}
    });
  },
  setpwd(params) {
    let param = {
      loginName: params.loginName,
      passwd: params.passwd,
      newPwd: params.newPwd
    }
    return fetch.post(_URL.setpwd, param, {
      headers:{'x-time': params.timestamp}
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/login.js